var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{on:{"submit":_vm.addWaterHistory,"cancel":function($event){return _vm.$emit('cancel')}},scopedSlots:_vm._u([{key:"button",fn:function(){return [_vm._v("Save "),_c('v-icon',[_vm._v("mdi-content-save")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }